import Lookup from 'src/componentes/select2';

const FrequenciaControleLookup = ({ clearable = false, ...props }) => (
  <Lookup
    labelKey="descricao"
    valueKey="id"
    url="/FrequenciaControleLookup"
    clearable={clearable}
    {...props}
  />
);

export default FrequenciaControleLookup;
